<style scoped>
</style>

<template>
  <div>
    <Card shadow>
      <Button @click="showAddUpdateRecordModal" type="primary" icon="md-add">新增记录</Button>
      <Table
        border
        stripe
        :columns="tdata.col_data"
        :data="tdata.current_data"
        :loading="tdata.loading"
        style="margin-top:10px"
        @on-row-click="rowSelect"
      >
        <template slot-scope="{row}" slot="opt">
          <Button size="small" @click.stop="setActive(row)" v-if="row.isactive == 0">激活</Button>
          <Button
            size="small"
            @click.stop="setActive(row)"
            v-else-if="row.isactive == 1"
            type="success"
          >取消激活</Button>
        </template>
      </Table>
      <Modal v-model="addUpadteRecordModal.modal" title="新增更新记录">
        <Input
          type="textarea"
          :rows="4"
          placeholder="填写更新记录..."
          v-model="addUpadteRecordModal.model.content"
        />
        <div slot="footer">
          <Button type="text" size="large" @click="addUpdateCancel">取消</Button>
          <Button type="primary" size="large" @click="addUpdateSubmit">确定</Button>
        </div>
      </Modal>
      <Modal v-model="showUpdateModal.modal" title="更新记录">
        <pre>{{showUpdateModal.model.updateinfo}}</pre>
      </Modal>
    </Card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addUpadteRecordModal: {
        modal: false,
        model: {},
      },
      showUpdateModal: {
        modal: false,
        model: {},
      },
      tdata: {
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "index",
            width: 60,
            align: "center",
          },
          {
            title: "发布日期",
            key: "createtime",
          },
          {
            title: "操作",
            slot: "opt",
          },
        ],
      },
    };
  },
  methods: {
    showAddUpdateRecordModal() {
      this.addUpadteRecordModal.modal = true;
    },
    addUpdateCancel() {
      this.addUpadteRecordModal.modal = false;
    },
    addUpdateSubmit() {
      let _this = this;
      this.$http.post({
        method: "/base/sysupdate/add",
        params: this.addUpadteRecordModal.model,
        success: function (data) {
          _this.addUpadteRecordModal.modal = false;
          _this.getUpdateList();
        },
        failure(code, msg) {
          _this.$Message.warning(msg);
        },
      });
    },
    getUpdateList() {
      let _this = this;
      this.$http.get({
        method: "base/sysupdate/list",
        params: {},
        success: function (data) {
          _this.tdata.current_data = data;
        },
        failure(code, msg) {},
      });
    },
    setActive(row) {
      if (row.isactive == 0) {
        let _this = this;
        this.$http.post({
          method: "/base/sysupdate/setActive",
          params: {
            id: row.id,
          },
          success: function (data) {
            _this.getUpdateList();
          },
          failure(code, msg) {
            _this.$Message.warning(msg);
          },
        });
      } else if (row.isactive == 1) {
        let _this = this;
        this.$http.post({
          method: "/base/sysupdate/setUnactive",
          params: {
            id: row.id,
          },
          success: function (data) {
            _this.getUpdateList();
          },
          failure(code, msg) {
            _this.$Message.warning(msg);
          },
        });
      }
    },
    rowSelect(row) {
      this.showUpdateModal.modal = true;
      this.showUpdateModal.model = row;
    },
  },
  mounted() {
    this.getUpdateList();
  },
};
</script>